module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-discount-rate-update"
  }, [_c('h2', [_vm._v("\n        Claims Preview\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap"
  }, [_c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('discount-rate-options')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-1"
  }, [(_vm.discountRatesOptions) ? _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "discount-rate-warning"
    }
  }, [(_vm.claimsToBeUpdatedTotal > 1) ? _c('button', {
    staticClass: "a-button a-button--small u-no-margin"
  }, [_vm._v("\n                    Apply\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.claimsToBeUpdatedTotal < 1) ? _c('button', {
    staticClass: "a-button a-button--small u-no-margin",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                Apply\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-your-claims u-no-padding"
  }, [_c('div', {
    staticClass: "p-your-claims__table-container"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width your-claims-table p-your-claims__table"
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', [_c('div', {
    staticClass: "a-checkbox p-discount-rate-update__select-all-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "all",
      "checked": ""
    },
    on: {
      "change": _vm.selectAll
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Value at New Current Discount Rate (" + _vm._s(_vm.discountRates[_vm.updateDiscountRate]) + ")\n                        ")])]), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preview.data), function(claim, index) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "a-checkbox u-margin-top-10"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": "claimId"
      },
      domProps: {
        "value": claim.id,
        "checked": claim.selected
      },
      on: {
        "click": function($event) {
          return _vm.updateSelected(claim.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ""
      }
    })])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(claim.yourReference) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(claim.humanClaimType) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(claim.claimantName) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(claim.defendantName) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(claim.discountRate) + "%\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(claim.headsOfLossTotal)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(claim.headsOfLossPreview)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.showDifference(claim.headsOfLossTotal, claim.headsOfLossPreview))) + "\n                    ")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "p-discount-rate-update__total u-margin-top-20"
  }, [_c('h3', [_vm._v("Total Difference For All Claims")]), _vm._v("\n        " + _vm._s(_vm.currencyFormat(_vm.totalDifference())) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-center flex-grid--column p-discount-rate-comparison__pie-container u-margin-top-50"
  }, [_c('h3', [_vm._v("Comparison Between Discount Rates")]), _vm._v(" "), _c('pie', {
    attrs: {
      "labels": ['Current Discount Rate', 'New Discount Rate'],
      "dataset": _vm.dataset(),
      "total": _vm.totalDifference(),
      "totalText": "Total Difference"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "values": [
        'Current Discount Rate',
        'New Discount Rate'
      ],
      "legendWidth": _vm.chartLegendWidth,
      "marginTop": "30",
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "discount-rate-warning",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("Warning")]), _vm._v("\n        You are about the change the discount rate to " + _vm._s(_vm.discountRates[_vm.updateDiscountRate]) + " on " + _vm._s(_vm.claimsToBeUpdatedTotal) + " claim(s)."), _c('br'), _c('br'), _vm._v("\n        This process can take several minutes "), _c('br'), _c('br'), _vm._v("\n        In this time you will not be able to use this feature or update the discount rate until this process has finished. "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small u-no-margin",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small u-no-margin",
    on: {
      "click": _vm.startUpdateDiscountRate
    }
  }, [_vm._v("Apply")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Your Reference\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Claim Type\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Claimant Name\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Defendant Name\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Current Discount Rate\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Current Value\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            Difference\n                        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d0f40b1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/update/ClaimsPreview.vue
// module id = 1651
// module chunks = 0